define('../src/sublayouts/m26-pagination/m26-pagination',['jquery', 'slick'], function ($) {

	'use strict';

	var M26_PAGINATION = function ($component) {

		this.$component = $component;

		return this;
	};

	M26_PAGINATION.prototype.init = function () {
		var _this = this,
			number = _this.$component.data('list');
		_this.initPagination(number)
	};
	M26_PAGINATION.prototype.initPagination = function(count){
		
	}

	return M26_PAGINATION;
});

